/** Converts app event names to GA4-safe snake_case event names. */
export function sanitizeGaEventName(eventName: string): string {
  return eventName
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .replace(/__+/g, '_')
    .toLowerCase()
}
